export const REQUEST_ASSET_DOWNLOAD_CLOUDFRONT = 'asset/REQUEST_ASSET_DOWNLOAD_CLOUDFRONT' as const;
export const REQUEST_ASSET_DOWNLOAD_CLOUDFRONT_SUCCESS =
  'asset/REQUEST_ASSET_DOWNLOAD_CLOUDFRONT_SUCCESS' as const;
export const REQUEST_ASSET_DOWNLOAD_CLOUDFRONT_FAILURE =
  'asset/REQUEST_ASSET_DOWNLOAD_CLOUDFRONT_FAILURE' as const;

export const REQUEST_INTERVIEW_DOWNLOAD_CLOUDFRONT = 'asset/REQUEST_INTERVIEW_DOWNLOAD_CLOUDFRONT' as const;
export const REQUEST_INTERVIEW_DOWNLOAD_CLOUDFRONT_SUCCESS =
  'asset/REQUEST_INTERVIEW_DOWNLOAD_CLOUDFRONT_SUCCESS' as const;
export const REQUEST_INTERVIEW_DOWNLOAD_CLOUDFRONT_FAILURE =
  'asset/REQUEST_INTERVIEW_DOWNLOAD_CLOUDFRONT_FAILURE' as const;

export const REQUEST_HIGHLIGHT_DOWNLOAD_CLOUDFRONT = 'asset/REQUEST_HIGHLIGHT_DOWNLOAD_CLOUDFRONT' as const;
export const REQUEST_HIGHLIGHT_DOWNLOAD_CLOUDFRONT_SUCCESS =
  'asset/REQUEST_HIGHLIGHT_DOWNLOAD_CLOUDFRONT_SUCCESS' as const;
export const REQUEST_HIGHLIGHT_DOWNLOAD_CLOUDFRONT_FAILURE =
  'asset/REQUEST_HIGHLIGHT_DOWNLOAD_CLOUDFRONT_FAILURE' as const;

/**
 * Asset
 */
export const REQUEST_ASSET_LIST = 'asset/REQUEST_ASSET_LIST' as const;
export const REQUEST_ASSET_LIST_SUCCESS = 'asset/REQUEST_ASSET_LIST_SUCCESS' as const;
export const REQUEST_ASSET_LIST_FAILURE = 'asset/REQUEST_ASSET_LIST_FAILURE' as const;

export const REQUEST_ASSET = 'asset/REQUEST_ASSET' as const;
export const REQUEST_ASSET_SUCCESS = 'asset/REQUEST_ASSET_SUCCESS' as const;
export const REQUEST_ASSET_FAILURE = 'asset/REQUEST_ASSET_FAILURE' as const;

export const REQUEST_ASSET_DOWNLOAD = 'asset/REQUEST_ASSET_DOWNLOAD' as const;
export const REQUEST_ASSET_DOWNLOAD_SUCCESS = 'asset/REQUEST_ASSET_DOWNLOAD_SUCCESS' as const;
export const REQUEST_ASSET_DOWNLOAD_FAILURE = 'asset/REQUEST_ASSET_DOWNLOAD_FAILURE' as const;

export const REQUEST_ASSET_DOWNLOAD_S3 = 'asset/REQUEST_ASSET_DOWNLOAD_S3' as const;
export const REQUEST_ASSET_DOWNLOAD_S3_SUCCESS = 'asset/REQUEST_ASSET_DOWNLOAD_S3_SUCCESS' as const;
export const REQUEST_ASSET_DOWNLOAD_S3_FAILURE = 'asset/REQUEST_ASSET_DOWNLOAD_S3_FAILURE' as const;

export const REQUEST_ASSET_DOWNLOAD_S3_FROM_WEB_SERVER =
  'asset/REQUEST_ASSET_DOWNLOAD_S3_FROM_WEB_SERVER' as const;
export const REQUEST_ASSET_DOWNLOAD_S3_FROM_WEB_SERVER_SUCCESS =
  'asset/REQUEST_ASSET_DOWNLOAD_S3_FROM_WEB_SERVER_SUCCESS' as const;
export const REQUEST_ASSET_DOWNLOAD_S3_FROM_WEB_SERVER_FAILURE =
  'asset/REQUEST_ASSET_DOWNLOAD_S3_FROM_WEB_SERVER_FAILURE' as const;

export const SELECT_QUARTER = 'asset/SELECT_QUARTER';
export const SET_QUARTER_LIST = 'asset/SET_QUARTER_LIST';
